import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { Project } from '../../../model/project/project';
import ProjectHelper from '../../../helpers/project-helper';
import {
  DEBOUNCE_TIME,
  RequestService,
} from '../../../services/request.service';
import { SubscriptionBasedComponent } from '../../../subscription-helpers/subscription-based.component';
import { Subject } from 'rxjs';
import Product from '../../../model/product/product';
import { LoadingService } from '../../../services/loading.service';
import { IdAssignmentObserver } from '../../../helpers/id-assignment-observer';
import {
  SubProject,
  SUB_PROJECT_TYPES,
} from '../../../model/project/sub-project';
import { Adjustment } from '../../../model/project/adjustment';
import { Repo } from '../../../model/project/repo';
import { SoldRented } from '../../../model/project/sold-rented';
import { EditViewPickerComponent } from '../../../components/edit-view-picker/edit-view-picker.component';
import { ProjectPlacement } from '../../../model/project/projectPlacement';
import Address from '../../../model/project/address';
import { GeneralHelper } from 'src/app/helpers/general-helper';
import ProjectContact from 'src/app/model/company/projectContact';
import { SubProjectCount } from 'src/app/helpers/sub-project-count';
import { BoardPartAddedEvent } from 'src/app/events/board-part-added';
import { ProductTypes } from 'src/app/model/product/product-type';
import Board from 'src/app/model/product/board/board';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import Windowsticker from 'src/app/model/product/windowsticker/windowsticker';
import { StandardStickerPartAddedEvent } from 'src/app/events/standard-sticker-part-added';
import { StandardStickerPartDeletedEvent } from 'src/app/events/standard-sticker-part-deleted';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import BoardConstructionMaterial from 'src/app/model/product/board/board-construction-materials';
import IPBoard from '../../../model/product/ip-board/ip-board';
import ProductHelper from '../../../helpers/product-helper';
import { ProjectTabsContainerHelper } from './project-tabs-container-helper';

@Component({
  selector: 'app-project-tabs-container',
  templateUrl: './project-tabs-container.component.html',
  styleUrls: ['./project-tabs-container.component.scss'],
})
export class ProjectTabsContainerComponent
  extends SubscriptionBasedComponent
  implements OnInit
{
  @ViewChild(EditViewPickerComponent)
  childcomp: EditViewPickerComponent;

  @Input()
  newSubProjectType: string;

  @Input()
  fromImmo: boolean;

  project = new Project();
  model = new SubProject();
  init = false;
  setTabName = false;
  activeProject: SubProject;
  public isSaving = false;
  private isIPBoardProject = false;
  private projectChanged: Subject<boolean> = new Subject<boolean>();
  private projectChangedImmediateSave: Subject<string> = new Subject<string>();
  public projectContactIdAssigned: Subject<ProjectContact[]> = new Subject<
    ProjectContact[]
  >();
  productAdded: Subject<Product> = new Subject<Product>();
  boardPartAdded: Subject<BoardPartAddedEvent> =
    new Subject<BoardPartAddedEvent>();
  standardStickerPartAdded: Subject<StandardStickerPartAddedEvent> =
    new Subject<StandardStickerPartAddedEvent>();
  standardStickerPartDeleted: Subject<StandardStickerPartDeletedEvent> =
    new Subject<StandardStickerPartDeletedEvent>();
  private idAssignmentObserver: IdAssignmentObserver;
  private subProjectCount: SubProjectCount;

  constructor(
    private requestService: RequestService,
    private loadingService: LoadingService,
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit() {
    if (this.newSubProjectType != null) {
      this.model.type = this.newSubProjectType;
      if (this.model.type === SUB_PROJECT_TYPES.REPO) {
        const repo = <Repo>this.model;
        repo.repoByInpress = true;
        repo.handleByAtelier = false;
      } else {
        (<Adjustment>this.model).handleByAtelier = true;
      }
    }
    this.activeProject = this.model;
    if (this.project.id) {
      this.requestService
        .getNormal('/projects/' + this.project.id)
        .subscribe((res) => {
          this.initProject(res);
        });
    } else {
      if (this.newSubProjectType != null) {
        this.addSubproject(this.model, true);
      }
      this.subProjectCount = new SubProjectCount(this.project);
      this.init = true;
    }
    this.addSubscription(
      this.projectDisplayObservableService.getMergedProjectProductPlacementVariableChangedSubscribable(),
      () => this.calculateSubProjectsExecuted()
    );
    this.addSubscription(
      this.projectChanged,
      (b) => {
        this.saveToServer(b);
      },
      (err) => {},
      DEBOUNCE_TIME
    );
    this.addSubscription(this.projectChangedImmediateSave, () => {
      this.saveToServer();
    });
  }

  getActive(subproject: SubProject) {
    return subproject.id == this.activeProject.id;
  }

  saveToServer(b?: boolean) {
    if (this.project.id) {
      this.project.products = this.project.products.filter((p) => {
        return p.type != null;
      });
      this.addSubscription(
        this.requestService.put(this.project, '/projects'),
        (res) => {
          this.broadcastProjectContactIdAssignment(
            this.project.projectContacts,
            res.projectContacts
          );
          this.project.projectContacts = res.projectContacts;
          this.setProject(res);
          this.setNewProductIds(res);
          this.setNewProjectContactIds(res);
          this.setMinuteBudgets(res);
          this.setNewProductPhoneNumberIds(res);
          this.isSaving = false;
          this.loadingService.isSaved();
          this.setTabName = true;
          if (
            b &&
            this.project.subProjects != null &&
            this.project.subProjects.length > 0
          ) {
            this.openTab(
              this.project.subProjects[this.project.subProjects.length - 1],
              true,
              true
            );
          }
        }
      );
    } else {
      let toCreateProject = new Project();
      GeneralHelper.copy(toCreateProject, this.project);
      toCreateProject.products = this.project.products.filter((p) => {
        return p.type != null;
      });
      this.addSubscription(
        this.requestService.post(toCreateProject, '/projects', 'json'),
        (res) => {
          this.project.id = res.id;
          this.setProject(res);
          this.setNewProductIds(res);
          this.setNewProjectContactIds(res);
          this.setMinuteBudgets(res);
          this.setNewProductPhoneNumberIds(res);
          this.isSaving = false;
          if (this.idAssignmentObserver != null) {
            this.idAssignmentObserver.notifyIdAssignment(
              ProjectTabsContainerComponent,
              this.project,
              'Project #',
              this.project.id,
              ProjectHelper.getBaseProject(this.project).id
            );
          }
          this.loadingService.isSaved();
          this.openTab(this.project.subProjects[0]);
        }
      );
    }
  }

  saveSubProject(value) {
    if (this.project.subProjects == null) {
      this.project.subProjects = [value];
    } else if (this.project.subProjects.length === 0) {
      this.project.subProjects.push(value);
    } else {
      let i = ProjectHelper.getSubIndexWithId(this.project, value.id);
      this.project.subProjects[i] = value;
    }
    this.saveProject();
  }

  saveProject(switchToLatestSubProject?: boolean) {
    // this.project = ProjectHelper.setBaseProject(
    //   this.project,
    //   this.model,
    //   overwriteBaseProject
    // );
    this.isSaving = true;
    this.loadingService.isLoading();
    this.projectChanged.next(switchToLatestSubProject);
  }

  openTab(
    subproject: SubProject,
    notifyChild?: boolean,
    newSubProject?: boolean
  ) {
    if (subproject.projectPlacement == null) {
      subproject.projectPlacement = new ProjectPlacement();
    }
    if (subproject.projectPlacement.address == null) {
      subproject.projectPlacement.address = new Address();
    }
    this.activeProject = subproject;
    if (notifyChild) {
      this.childcomp.subProjectChanged.next({
        subProject: subproject,
        doLoadRequest: false,
      });
    }
  }

  setNewProductIds(updatedProj) {
    if (updatedProj.products == null || updatedProj.products.length === 0) {
      return;
    }
    this.project.products.forEach((p, i) => {
      let emitAdded = false;
      if (p.id == null) {
        p.id = updatedProj.products[i].id;
        emitAdded = true;
      }
      if (
        p.productPlacement != null &&
        p.productPlacement.id == null &&
        updatedProj.products[i].productPlacement != null
      ) {
        p.productPlacement.id = updatedProj.products[i].productPlacement.id;
      }
      if (
        p.productPlacement != null &&
        p.productPlacement.id != null &&
        updatedProj.products[i].productPlacement != null
      ) {
        p.productPlacement.placedRegistration =
          updatedProj.products[i].productPlacement.placedRegistration;
      }
      //check on size?
      p.productSize = updatedProj.products[i].productSize;
      p.spellCheckRegistration = updatedProj.products[i].spellCheckRegistration;
      p.designSentLog = updatedProj.products[i].designSentLog;
      p.designApprovalRegistration =
        updatedProj.products[i].designApprovalRegistration;
      p.printWorkReadyRegistration =
        updatedProj.products[i].printWorkReadyRegistration;
      p.finishReadyRegistration =
        updatedProj.products[i].finishReadyRegistration;
      p.titleCheckedDesignRegistration =
        updatedProj.products[i].titleCheckedDesignRegistration;
      p.phoneNumberCheckedDesignRegistration =
        updatedProj.products[i].phoneNumberCheckedDesignRegistration;
      p.titleCheckedPrintWorkRegistration =
        updatedProj.products[i].titleCheckedPrintWorkRegistration;
      this.handleProductAssets(p, i, updatedProj);
      if (emitAdded) {
        this.productAdded.next(p);
        this.projectDisplayObservableService
          .getProductAddedSubscribable()
          .next();
      }
      if (p.type === ProductTypes.BOARD.value) {
        if ((<Board>p).boardConstructionMaterials != null) {
          this.handleBoardConstructionMaterials(p, i, updatedProj);
        }
        if ((<Board>p).boardParts != null) {
          this.emitPossibleBoardPartsAdded(p, i, updatedProj);
        }
      }
      if (
        p.type === ProductTypes.WINDOWSTICKER.value &&
        (<Windowsticker>p).standardStickerParts != null
      ) {
        this.emitPossibleStandardStickerPartsAdded(p, i, updatedProj);
      }
    });
  }

  handleBoardConstructionMaterials(
    b: Board,
    i: number,
    updatedProj: Project
  ): void {
    b.boardConstructionMaterials.forEach(
      (m: BoardConstructionMaterial, j: number) => {
        if (m.id == null) {
          m.id = (<Board>updatedProj.products[i]).boardConstructionMaterials[
            j
          ].id;
        }
      }
    );
  }

  emitPossibleBoardPartsAdded(p, i, updatedProj) {
    p.boardParts.forEach((part, j) => {
      if (part.id == null) {
        part.id = updatedProj.products[i].boardParts[j].id;
        this.boardPartAdded.next({ boardId: p.id, boardPart: part });
      }
    });
  }

  emitPossibleStandardStickerPartsAdded(p, i, updatedProj) {
    p.standardStickerParts.forEach((part, j) => {
      if (part.id == null) {
        part.id = updatedProj.products[i].standardStickerParts[j].id;
        if (p.standardStickerParts.length > 1) {
          this.standardStickerPartAdded.next({
            windowStickerId: p.id,
            standardStickerPart: part,
          });
        }
      }
    });
  }

  handleProductAssets(p: Product, i: number, updatedProj: Project): void {
    if (CollectionHelper.isPopulated(p.productAssets)) {
      p.productAssets.forEach((pa, j) => {
        if (pa.id == null) {
          pa.id = updatedProj.products[i].productAssets[j].id;
        }
      });
    }
  }

  setNewProjectContactIds(updatedProj) {
    let nonIdContacts: ProjectContact[] = [];
    this.project.projectContacts.forEach((pc, i) => {
      if (pc.id == null) {
        pc.id = updatedProj.projectContacts[i].id;
        nonIdContacts.push(updatedProj.projectContacts[i]);
      }
    });
    if (nonIdContacts.length > 0) {
      this.projectContactIdAssigned.next(nonIdContacts);
    }
  }

  broadcastProjectContactIdAssignment(oldContacts, newContacts) {
    if (
      oldContacts != null &&
      oldContacts.length > 0 &&
      newContacts != null &&
      newContacts.length > 0
    ) {
      let nonIdContacts: ProjectContact[] = [];
      oldContacts.forEach((oPc) => {
        if (oPc.contact == null || oPc.company == null) {
          return;
        }
        if (oPc.id == null) {
          const matchingContact = newContacts.find(
            (nPc) =>
              nPc.contact != null &&
              nPc.company != null &&
              oPc.contact.id === nPc.contact.id &&
              oPc.company.id === nPc.company.id
          );
          if (matchingContact != null) {
            nonIdContacts.push(matchingContact);
          }
        }
      });
      if (nonIdContacts.length > 0) {
        this.projectContactIdAssigned.next(nonIdContacts);
      }
    }
  }

  setProject(updatedProj) {
    if (this.project.subProjects != null) {
      this.project.subProjects.forEach((sp, i) => {
        if (sp.id == null) {
          sp.id = updatedProj.subProjects[i].id;
        }
        if (sp.projectUser == null) {
          sp.projectUser = updatedProj.subProjects[i].projectUser;
        }
        if (sp.currentCreatedAt == null) {
          sp.currentCreatedAt = updatedProj.subProjects[i].currentCreatedAt;
        }
        if (sp.pickup != null && sp.pickup.id == null) {
          sp.pickup.id = updatedProj.subProjects[i].pickup.id;
        }
        sp.onHoldHandled = updatedProj.subProjects[i].onHoldHandled;
        if (sp.projectPlacement != null && sp.projectPlacement.id == null) {
          sp.projectPlacement.id =
            updatedProj.subProjects[i].projectPlacement.id;
        }
        if (sp.projectInvoices != null) {
          sp.projectInvoices.forEach((pi, j) => {
            if (pi.id == null) {
              pi.id = updatedProj.subProjects[i].projectInvoices[j].id;
            }
          });
        }
        if (sp.quotation != null) {
          if (sp.quotation.id == null) {
            sp.quotation.id = updatedProj.subProjects[i].quotation.id;
          }
          sp.quotation.approvalRegistration =
            updatedProj.subProjects[i].quotation.approvalRegistration;
          sp.quotation.sentRegistration =
            updatedProj.subProjects[i].quotation.sentRegistration;
        }
        if (sp.projectPlacement != null) {
          sp.projectPlacement.placementDoneRegistration =
            updatedProj.subProjects[
              i
            ].projectPlacement.placementDoneRegistration;
          sp.projectPlacement.siteVisitExecutedRegistration =
            updatedProj.subProjects[
              i
            ].projectPlacement.siteVisitExecutedRegistration;
          sp.projectPlacement.locationVerifiedRegistration =
            updatedProj.subProjects[
              i
            ].projectPlacement.locationVerifiedRegistration;
          sp.projectPlacement.locationVerificationCheckedByExpertRegistration =
            updatedProj.subProjects[
              i
            ].projectPlacement.locationVerificationCheckedByExpertRegistration;
          sp.projectPlacement.appointmentReadyRegistration =
            updatedProj.subProjects[
              i
            ].projectPlacement.appointmentReadyRegistration;
          sp.projectPlacement.appointmentFailureRegistration =
            updatedProj.subProjects[
              i
            ].projectPlacement.appointmentFailureRegistration;
        }
        sp.delayedRegistration = updatedProj.subProjects[i].delayedRegistration;
        sp.approvedRegistration =
          updatedProj.subProjects[i].approvedRegistration;
        if (
          sp.type === 'Adjustment' ||
          sp.type === 'SoldRented' ||
          sp.type === 'Repo'
        ) {
          let adjustment = <Adjustment>sp;
          let returnAdjustment = <Adjustment>updatedProj.subProjects[i];
          adjustment.spellCheckRegistration =
            returnAdjustment.spellCheckRegistration;
          adjustment.designSentLog = returnAdjustment.designSentLog;
          adjustment.designApprovalRegistration =
            returnAdjustment.designApprovalRegistration;
          adjustment.designFinishedLog = returnAdjustment.designFinishedLog;
          adjustment.printWorkReadyRegistration =
            returnAdjustment.printWorkReadyRegistration;
          adjustment.finishReadyRegistration =
            returnAdjustment.finishReadyRegistration;
          adjustment.pending = returnAdjustment.pending;
        }
      });
      this.subProjectCount.recalculate(this.project);
    }
  }

  initProject(project: Project): Project {
    this.project = project;
    this.isIPBoardProject = ProjectHelper.isIPBoardProject(project);
    if (this.isIPBoardProject) {
      this.project.products.forEach((product) => {
        if (ProductHelper.isIPBoard(product)) {
          (product as IPBoard).leftRightBoard =
            (product as IPBoard).otherSideBoardPart != null;
        }
      });
    }
    if (this.newSubProjectType != null) {
      this.addSubproject(this.model, true);
    }
    if (CollectionHelper.isPopulated(project.subProjects)) {
      const activeProject = project.subProjects.find((sp) => {
        return sp.id === this.model.id;
      });
      if (activeProject != null) {
        this.activeProject = activeProject;
      }
    }
    this.calculateSubProjectsExecuted();
    this.subProjectCount = new SubProjectCount(this.project);
    this.init = true;
    return project;
  }

  setMinuteBudgets(updatedProj) {
    this.project.products.forEach((p, i) => {
      if (p.productSize != null) {
        p.designerHourBudget = updatedProj.products[i].designerHourBudget;
        p.designerMinuteBudget = updatedProj.products[i].designerMinuteBudget;
        if (
          p.productPlacement != null &&
          updatedProj.products[i].productPlacement != null
        ) {
          p.productPlacement.installerMinuteBudget =
            updatedProj.products[i].productPlacement.installerMinuteBudget;
        }
      }
    });
  }

  setNewProductPhoneNumberIds(updatedProj) {
    this.project.products.forEach((p, i) => {
      if (p.productPhoneNumbers != null) {
        p.productPhoneNumbers.forEach((ppn, j) => {
          if (ppn.id == null) {
            ppn.id = updatedProj.products[i].productPhoneNumbers[j].id;
          }
        });
      }
    });
  }

  addAdjustment() {
    this.addSubproject(new Adjustment());
  }

  addSoldRented() {
    this.addSubproject(new SoldRented());
  }

  addRepo() {
    this.addSubproject(new Repo());
  }

  addSubproject(subProject: SubProject, addedFromProjectsTable = false) {
    let address = {
      ...ProjectHelper.getBaseProject(this.project).projectPlacement.address,
    };
    delete address.id;
    delete address.coordinates;
    subProject.projectPlacement.address = address;
    subProject.projectInvoices = [];
    ProjectTabsContainerHelper.copyRecurringInternalInfoFromMostRecentSubProject(
      subProject,
      this.project
    );
    this.project.subProjects.push(subProject);
    this.calculateSubProjectsExecuted();
    this.saveProject(!addedFromProjectsTable);
  }

  getTitle(sub: SubProject): string {
    if (this.subProjectCount == null) {
      return ProjectHelper.getSubProjectTypeTitle(
        sub,
        false,
        true,
        this.isIPBoardProject
      );
    }
    return this.subProjectCount.getTabTitleDisplay(
      sub,
      this.isIPBoardProject,
      this.project.oldPlatformId
    );
  }

  subProjectDeleted() {
    this.activeProject.archived = true;
    this.openTab(ProjectHelper.getBaseProject(this.project));
    this.subProjectCount.recalculate(this.project);
  }

  calculateSubProjectsExecuted() {
    if (this.project == null || this.project.subProjects == null) {
      return;
    }
    this.project.subProjects.forEach(
      (sp) =>
        (sp.showExecutedCheck = ProjectHelper.getIsExecuted(sp, this.project))
    );
  }
}
